import { Component } from '@angular/core';
import {Field} from "../../models/field.model";
import {ENVIRONMENT} from "../../../../../environments/environment";

@Component({
  selector: 'tig-form-links',
  templateUrl: './form-links.component.html',
  styleUrls: ['./form-links.component.scss']
})
export class FormLinksComponent extends Field {

	STR_wcms: string = "";

	constructor() {
		super();
		if (ENVIRONMENT.env === 'development') {
			this.STR_wcms = 'wcms/';
		} // end if

	} // end constructor

}
